import { NotFound } from '@atlassian/mpac-primitives';
import Telemetry from '@atlassian/mpac-telemetry';
import React, { useLayoutEffect } from 'react';
import { productInfoMap } from './constants';
import { ProductHomepageView } from './ProductHomepageView';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHomepage = _ref => {
  let {
    productId
  } = _ref;
  const productInfo = productInfoMap[productId];
  useLayoutEffect(() => {
    Telemetry.timeToFirstMeaningfulPaint(performance.now());
  }, []);
  if (!productInfo) {
    return /*#__PURE__*/_jsx(NotFound, {});
  }
  return /*#__PURE__*/_jsx(ProductHomepageView, {
    productInfo: productInfo,
    productId: productId
  });
};